import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";

import Table from "containers/Table/Table";

import breakpoints from "_constants/breakpoints";

const DATE_TIME_WIDTH = 130;

const Container = styled.div`
  padding: 48px 32px 56px;
  margin-bottom: 33px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      padding: 33px 12px 14px;

      @media (max-width: ${breakpoints.mobileM}) {
        padding: 16px 8px;
      }
    `}
`;
const Footer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          flex-direction: column;
          align-items: center;
        `
      : css`
          @media (max-width: 700px) {
            justify-content: space-evenly;
            gap: 12px;
          }
        `};
`;
const Button = styled.button`
  width: 160px;
  height: 52px;
  background: #f37217;
  border: none;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #fafaff;
  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          &:not(:last-child) {
            margin-bottom: 10px;
          }
        `
      : css`
          @media (max-width: 700px) {
            height: 52px;
          }
        `}
`;
const EmptyNotes = styled.div`
  padding: 16px 12px;
`;

function OrderStatus({ orderId, notes = [], specimen, search, monitoring }) {
  const navigate = useNavigate();

  const columns = [
    {
      label: "DATE & TIME",
      key: [
        { key: "date", format: "MMM DD, YYYY" },
        { key: "date", format: "hh:mm A" },
      ],
      width: DATE_TIME_WIDTH,
      textAlign: "center",
    },
    { label: "DESCRIPTION", key: "message", textAlign: "left" },
  ];

  return (
    <Container>
      <Table data={notes} columns={columns} contentMaxHeight="180px" />
      {!notes.length && <EmptyNotes>No Events for this order</EmptyNotes>}
      <Footer>
        {specimen && (
          <Button onClick={() => navigate(`/orders/${orderId}/specimen`)}>
            Upload
            <br />
            Specimen/Website
          </Button>
        )}
        {search && <Button onClick={() => navigate(`/orders/${orderId}/search`)}>Search Results</Button>}
        {monitoring && <Button onClick={() => navigate(`/orders/${orderId}/monitoring`)}>Monitoring Reports</Button>}
      </Footer>
    </Container>
  );
}

OrderStatus.propTypes = {
  orderId: PropTypes.string.isRequired,
  notes: PropTypes.arrayOf(PropTypes.object),
  specimen: PropTypes.bool,
  search: PropTypes.bool,
  monitoring: PropTypes.bool,
};

export default OrderStatus;
